import {
    http,
    Header,
    ContentType,
    qs,
    GetFormData,
    StatusCode,
    Global,
    Method
} from './api-util';
import GoodsType from "../enum/GoodsType";

export async function jdGoodsPromotionUrl({itemId}) {
    return http({
        url: Global.BASE_URL + '/api/jd/goods/promotion-url',
        method: Method.GET,
        params: {
            itemId
        }
    }).then(res => res.data)
}

export async function pddGoodsPromotionUrl({goodsSign}) {
    return http({
        url: Global.BASE_URL + '/api/pdd/goods/promotion-url',
        method: Method.GET,
        params: {
            goodsSign
        }
    }).then(res => res.data)
}

export async function goodsPromotionUrl({goodsType, skuId}) {
    let shotUrl = '';

    if (goodsType === GoodsType.PDD) {
        const data = await pddGoodsPromotionUrl({goodsSign: skuId})
        shotUrl = data.shotUrl
    } else {
        const data = await jdGoodsPromotionUrl({itemId: skuId})
        shotUrl = data.shotUrl
    }

    return {
        shotUrl
    }
}